import { useEffect, useState } from "react";
import mammoth from "mammoth";
import UnsupportedPreview from "./UnsupportedPreview";

export default function DocxPreview({ arrayBuffer }) {
  const [html, setHtml] = useState("");

  useEffect(() => {
    mammoth
      .convertToHtml({ arrayBuffer })
      .then((result) => setHtml(result.value))
      .catch(() => setHtml(""));
  }, [arrayBuffer]);

  if (!html) {
    return <UnsupportedPreview type="DOCX" />;
  }

  return (
    <div
      className="docx-preview"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}